import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-remove-modal',
  templateUrl: './remove-modal.component.html',
  styleUrls: ['./remove-modal.component.css']
})
export class RemoveModalComponent implements OnInit {

  @Input() isOpenConfirmDeletePopup: boolean;
  @Input() title: string;

  @Output() closedModal: EventEmitter<boolean> = new EventEmitter();
  @Output() ConfirmRemove: EventEmitter<boolean> = new EventEmitter();

  public popupConfirmForm: FormGroup;
  public isConfirmWarning = false;

  constructor(private fb: FormBuilder) {
  }

  ngOnInit() {
    this.popupConfirmForm = this.fb.group({
      confirm_delete: [null]
    });
  }

  onPopUpConfirm(formValue) {
    const flag = this.isDeleteTextMatched();
    if (flag) {
      this.isConfirmWarning = false;
      this.ConfirmRemove.emit(true);
      this.closePopup();
    } else {
      this.isConfirmWarning = true;
      this.ConfirmRemove.emit(false);
    }
  }

  isDeleteTextMatched() {
    const val = this.popupConfirmForm.get('confirm_delete').value;
    if (val) {
      if (this.title.toLowerCase().includes('delete')) {
        return (val.trim() === 'DELETE') ? true : false;
      } else if (this.title.toLowerCase().includes('remove')) {
        return (val.trim() === 'REMOVE') ? true : false;
      }
    }
  }

  closePopup() {
    this.isConfirmWarning = false;
    this.popupConfirmForm.reset();
    this.isOpenConfirmDeletePopup = false;
    this.closedModal.emit(false);
  }

  isConfirmDeleteValid() {
    return this.popupConfirmForm.get('confirm_delete').errors
      && (this.popupConfirmForm.get('confirm_delete').touched
        || this.popupConfirmForm.get('confirm_delete').dirty);
  }

  removeValidaion(name) {
    const control = this.popupConfirmForm.get(name);
    control.reset();
    control.clearValidators();
    control.updateValueAndValidity();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/remove-modal/remove-modal.component.ts